export function requiredDeposit(subtotal, threshold) {
    if (!Number.isSafeInteger(subtotal) || subtotal < 0 ||
        !Number.isSafeInteger(threshold) || threshold <= 0) {
        throw new Error('Unable to calculate the appointment deposit.');
    }
    return subtotal > threshold ? threshold : 0;
}
